import { Fragment } from "react";
import styled, { useTheme } from "styled-components";
import { GetProfessionalsParams } from "../api/getProfessionals";
import { formatDate, incrementOnDate } from "../utils/date-util/dateUtils";
import { CancelIcon } from "./Icons";

const CurrentFiltersWrapper = styled.div`
	display: flex;
	overflow-x: auto;
	overflow-y: hidden;
	width: 100%;
	gap: 5px;
	padding: 16px 25px;
	box-sizing: border-box;
	height: 67px;
`;

const FilterWrapper = styled.div`
	display: flex;
	align-items: center;
	background-color: ${(props) => props.theme.colors.whiteVitat || "#EADCED"};
	border-radius: 8px;
	gap: 6px;
	box-sizing: border-box;
	height: 26px;
	padding: 6px;
	// Typography
	font-size: 12px;
	line-height: 18.86px;
	font-weight: 400;
	font-family: Livvic;
	color: ${(props) => props.theme.colors.blackVitat || "#002b49"};
	white-space: nowrap;
`;

const RemoveIconWrapper = styled.div``;

interface CurrentFiltersProps {
	filters: GetProfessionalsParams;
	handleChangeFilters: (newFilters: GetProfessionalsParams) => void;
}

const CurrentFilters = ({ filters, handleChangeFilters }: CurrentFiltersProps) => {
	const { colors } = useTheme();
	const capitalizeRegex = /(\b[a-z](?!\s))/g;

	const handleDate = (date: string) => {
		const today = formatDate("yyyy-MM-dd");
		const nextThreeDays = formatDate("yyyy-MM-dd", incrementOnDate(3, "days"));
		const nextWeek = formatDate("yyyy-MM-dd", incrementOnDate(1, "week"));
		if (date === today) return "Hoje";
		if (date === nextThreeDays) return "Próximos 3 dias";
		if (date === nextWeek) return "Próxima semana";
	};

	const showFilter = (key: keyof GetProfessionalsParams, value: string) => {
		switch (key) {
			case "price":
				return `Até R$ ${value}`;
			case "rating":
				return value === "3" ? `${value} estrelas` : `${value} ou mais estrelas`;
			case "tipoProfissional":
				if (value === "nutricionista") return "Nutrição"; 
				
				return value.replace("_", " ").replace(capitalizeRegex, x => x.toUpperCase());
			case "dataFinal":
				return handleDate(value);
			default:
				return value;
		}
	};

	const handleRemoveFilter = (key: keyof GetProfessionalsParams) => {
		filters[key] = undefined;
		handleChangeFilters(filters);
	};

	return (
		<CurrentFiltersWrapper>
			{Object.entries(filters).map(([key, value]) => {
				if (value) {
					return (
						<FilterWrapper key={key}>
							{showFilter(key as keyof GetProfessionalsParams, value)}
							<RemoveIconWrapper onClick={() => handleRemoveFilter(key as keyof GetProfessionalsParams)}>
								<CancelIcon size={13} color={colors.greenVitat || colors.secondary} />
							</RemoveIconWrapper>
						</FilterWrapper>
					);
				}
				return <Fragment key={key} />;
			})}
		</CurrentFiltersWrapper>
	);
};

export default CurrentFilters;
